import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initAuthFromMobile } from '../utils/webAuthBridge';

const SSOInitPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        const result = await initAuthFromMobile();

        if (result.success && result.pluginRoute) {
          // Navigate to the plugin route
          navigate(result.pluginRoute, { replace: true });
        } else {
          setError(result.error || 'Failed to initialize authentication');
          setLoading(false);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error occurred');
        setLoading(false);
      }
    };

    initialize();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        {loading ? (
          <div className="mt-8">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
            <p className="mt-4 font-semibold text-gray-600">Initializing Plugin...</p>
          </div>
        ) : (
          <div className="mt-8">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 max-w-md">
              <p className="text-red-800 font-semibold">Initialization Failed</p>
              <p className="text-red-600 text-sm mt-2">{error}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SSOInitPage;
